"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("./styled-components");
var _spinnerSvg = _interopRequireDefault(require("./spinner-svg"));
var Spinner = function Spinner(_ref) {
  var show = _ref.show;
  return /*#__PURE__*/_react.default.createElement(_styledComponents.Container, {
    className: show ? 'visible' : 'hidden'
  }, /*#__PURE__*/_react.default.createElement(_styledComponents.Mask, null), /*#__PURE__*/_react.default.createElement(_styledComponents.LoadingIndicator, null, /*#__PURE__*/_react.default.createElement(_spinnerSvg.default, null)));
};
Spinner.propTypes = {
  show: _propTypes.default.bool
};
Spinner.defaultProps = {
  show: false
};
var _default = exports.default = Spinner;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-select-plan/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');